import React, { useState } from 'react';

const NotificationCenter = ({ notifications = [], markNotificationAsRead, clearNotifications }) => {
    const [isOpen, setIsOpen] = useState(false);

    const unreadCount = notifications.filter(notif => !notif.read).length;

    const toggleNotifications = () => {
        setIsOpen(!isOpen);
    };

    const getNotificationClass = (type) => {
        switch (type) {
            case 'newLead': return 'alert-info';
            case 'statusChange': return 'alert-warning';
            case 'taskDue': return 'alert-danger';
            case 'documentUpload': return 'alert-success';
            default: return 'alert-info';
        }
    };

    return (
        <li className="dropdown" style={{ position: 'relative' }}>
            <a className="dropdown-toggle label-menu-corner" onClick={toggleNotifications}>
                <i className="pe-7s-speaker"></i>
                {unreadCount > 0 && <span className="label label-success">{unreadCount}</span>}
            </a>
            {isOpen && (
                <ul className="dropdown-menu hdropdown animated flipInX" style={{ position: 'absolute', right: 0, left: 'auto', display: 'block', width: '300px', maxHeight: '400px', overflowY: 'auto' }}>
                    <li>
                        <a>
                            <small>({unreadCount}) New Notifications</small>
                        </a>
                    </li>
                    {notifications.length > 0 ? (
                        notifications.map(notif => (
                            <li key={notif.id} className={!notif.read ? 'unread-notification' : ''} style={{ padding: '10px', borderBottom: '1px solid #eee', cursor: 'pointer' }} onClick={() => markNotificationAsRead(notif.id)}>
                                <a className={`alert ${getNotificationClass(notif.type)}`} style={{ marginBottom: '0', padding: '5px 10px' }}>
                                    <span style={{ fontWeight: !notif.read ? 'bold' : 'normal' }}>
                                        {notif.message}
                                        <br />
                                        <small className="pull-right">{new Date(notif.timestamp).toLocaleString()}</small>
                                    </span>
                                </a>
                            </li>
                        ))
                    ) : (
                        <li style={{ padding: '10px' }}>No new notifications.</li>
                    )}
                    {notifications.length > 0 && (
                        <li className="text-center">
                            <a onClick={clearNotifications} style={{ cursor: 'pointer' }}>Clear All Notifications</a>
                        </li>
                    )}
                </ul>
            )}
        </li>
    );
};

export default NotificationCenter; 